import { createElement } from 'react';
import { Card } from '@alifd/next';
import './index.scss';
const OadpCardHeader = function OadpCardHeader({ title, subTitle, extra, component, ...otherProps }) {
    return (createElement(Card.Header, Object.assign({ title: title, subTitle: subTitle, extra: extra, component: component }, otherProps)));
};
export default OadpCardHeader;
